import { render } from "./rigsbq.vue?vue&type=template&id=d47e1b32"
import script from "./rigsbq.vue?vue&type=script&lang=js"
export * from "./rigsbq.vue?vue&type=script&lang=js"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__